import React, { useState } from 'react';
import { restaurantAddOns } from '../../constants';
import Button from '../../shared/Button';
import { useDispatch } from 'react-redux';
import { addAddOn, addItemToBucket, removeItemFromBucket } from '../../features/bucket/bucketSlice';

const Accordion = ({data}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  const addToBucket = (data, addOn) => {
    dispatch(addItemToBucket({data:data, addOn:addOn}));
  };
  const addToppings= (addOn) => {
    let payload = {
      item: data,
      itemId: data.id,
      addOn
    }
    dispatch(addAddOn(payload));
  };
  const removeFromBucket = (data, addOn) => {
    dispatch(removeItemFromBucket(data, addOn));
  };

  return (
    <div>
      <button
        type="button"
        className="flex items-center justify-between w-full p-5 font-medium text-left border border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 bg-light-secondary text-white"
        onClick={toggleAccordion}
      >
        <span>Add Ons</span>
        <svg className={`w-3 h-3 ${!isOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 10 6">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
        </svg>
      </button>

      {isOpen && (
        <div className="p-5 border border-gray- bg-light-theme dark:border-gray-700 dark:bg-gray-900">
          {restaurantAddOns?.map((item) => (
            <div className="my-2 flex justify-between items-center">
                <div className='flex' gap-1>
                    <img src={item.image} alt='add-on' className='h-14 w-14' />
                    <div className='flex flex-col'>

                    <p>
                {item.name}
                    </p>
                    <p>

                (+Rs {item.price} )
                    </p>
                    </div>

                </div>
                <div>
                    <Button data="Add" type="solid" onClick={() => addToppings({item})} />
                </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Accordion;
